// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-NA1":"NA1_dpu-detail-NA1__ZeX_B"};